var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("ACCIDENT")]),_c('h4',[_vm._v("A visible, external, sudden and violent event occasioned by a physical or natural cause and occurring entirely beyond member's control causing damage to the health of the Member.")])])
}]

export { render, staticRenderFns }